import api from '@/api';
import i18n from '@/i18n';
import utilities from '@/helpers/utilities';

const state = {
    offices: [],
    scoreOffices: [],
    office: {},
};

const mutations = {
    setOffices(state, offices) {
        state.offices = offices;
    },
    setScoreOffices(state, scoreOffices) {
        state.scoreOffices = scoreOffices;
    },
    setOffice(state, office) {
        state.office = office;
    },
};

const actions = {
    async loadOffices({ commit }) {
        const response = await api.offices.list();
        commit('setOffices', response.data);
    },
    async getEvaluateOffices({ commit }) {
        const response = await api.offices.getEvaluateOffices();
        commit('setScoreOffices', response.data.output);
    },
    async fetchOffice({ commit }, id) {
        const response = await api.offices.get(id);
        commit('setOffice', response.data);
    },
    async saveOrUpdateOffice({ dispatch }, form) {
        if (utilities.isEmptyOrZero(form.id)) {
            await dispatch('saveOffice', form);
        } else {
            await dispatch('updateOffice', form);
        }

        await dispatch('loadOffices');
        dispatch('showSuccess', i18n.t('message.success.saved'));
    },
    async saveOffice({ dispatch }, form) {
        const response = await api.offices.save(form);

        await dispatch('fetchOffice', response.data.id);
    },
    async updateOffice({ dispatch }, form) {
        await api.offices.update(form.id, form);

        await dispatch('fetchOffice', form.id);
    },
};

const getters = {
    office() {
        return state.office || [];
    },
    offices() {
        return state.offices || [];
    },
    scoreOffices() {
        return state.scoreOffices || [];
    },
    officesValueText(_, getters) {
        return getters.offices.filter(i => !utilities.isEmptyOrZero(i.id))
            .map(({ id, acronym, name }) => ({ value: id, text: `${acronym} - ${name}` }));
    },
    officesDictionary(_, getters) {
        return getters.offices.reduce((map, obj) => {
            map[obj.id] = obj;
            return map;
        }, {});
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};


// WEBPACK FOOTER //
// ./src/store/modules/offices.js